import jwtInterceptor from "../interceptors/SetAuthToken";

const EMPLOYEE_API_BASE_URL = process.env.REACT_APP_API_BASE_URL + "/users";

class EmployeeService {
  getEmployees(params) {
    return jwtInterceptor.get(EMPLOYEE_API_BASE_URL, { params });
  }

  createEmployee(employee) {
    return jwtInterceptor.post(EMPLOYEE_API_BASE_URL, employee);
  }

  getEmployeeById(employeeId) {
    return jwtInterceptor.get(EMPLOYEE_API_BASE_URL + "/" + employeeId);
  }

  updateEmployee(employeeId, employee) {
    return jwtInterceptor.put(
      EMPLOYEE_API_BASE_URL + "/" + employeeId,
      employee
    );
  }

  getMe() {
    return jwtInterceptor.get(EMPLOYEE_API_BASE_URL + "/me");
  }

  deleteEmployee(employeeId) {
    return jwtInterceptor.delete(EMPLOYEE_API_BASE_URL + "/" + employeeId);
  }
}

export default new EmployeeService();
